"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireWildcard(require("lodash"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _Icon = _interopRequireDefault(require("../../../common/Icon"));

var _List = _interopRequireDefault(require("../../../common/List/List"));

var _Panel = _interopRequireDefault(require("../../../common/Panel/Panel"));

var _connectToMedia = _interopRequireDefault(require("../../Media/connectToMedia"));

var _Range = _interopRequireDefault(require("../../../utilities/transcriptLib/Range.js"));

var _index = require("../../../assets/icons/index");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PanelName = {
  Categories: "Categories",
  KeyWord: "KeyWord",
  Verb: "Verb",
  Phrase_Spotting: "Phrase Spotting",
  SelectedCat: "SelectedCat",
  Entities: "Entities"
};

var getCount = function getCount(keyword) {
  return Object.values(keyword.t).reduce(function (acc, speakerHits) {
    return acc + speakerHits.length;
  }, 0);
};

var getHits = function getHits(keyword) {
  if (!keyword.t && keyword.occurrences) {
    var test = keyword.occurrences.reduce(function (acc, item) {
      if (item.hits) {
        return acc.concat(item.hits);
      }

      return [].concat(acc, [item]);
    }, []);
    return test;
  }

  if (!keyword.t && keyword.hits) {
    var _test = keyword.hits.reduce(function (acc, item) {
      return [].concat(acc, [item]);
    }, []);

    return _test;
  }

  return Object.keys(keyword.t).map(function (speaker) {
    return keyword.t[speaker].map(function (time) {
      return {
        s: time,
        w: speaker
      };
    });
  }).reduce(function (acc, times) {
    return [].concat(acc, times);
  }, []);
};

var Keywords = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Keywords, _React$PureComponent);

  function Keywords() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      selection: null,
      categories: []
    });

    _defineProperty(_assertThisInitialized(_this), "getKeywordSelections", (0, _memoizeOne["default"])(function (queries) {
      return queries.filter(function (query) {
        return query.type === "keywords";
      }).map(function (query) {
        return query.parent;
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (selected, deselected) {
      var ranges = [];
      var isExternalHits = false;
      selected.forEach(function (obj) {
        var occurrences = (0, _lodash.get)(obj, "occurrences", [obj]);
        occurrences.forEach(function (occ) {
          if (occ.start && occ.end) {
            for (var i in occ.start) {
              var tempRange = new _Range["default"]({
                start: occ.start[i],
                end: occ.end[i],
                name: occ.exact
              });
              ranges.push(tempRange);
            }
          }

          if (occ.s && occ.e) {
            var _tempRange = new _Range["default"]({
              start: occ.s,
              end: occ.e,
              name: obj.text
            });

            ranges.push(_tempRange);
          }
        });
      });

      if (ranges.length) {
        _this.props.markTranscript(ranges);
      } else {
        _this.props.markTranscript(ranges);
      }

      if ((0, _lodash.has)(selected[0], "hits")) {
        selected[0].hits.map(function (hit) {
          if ((0, _lodash.has)(hit, "s")) {
            for (var i in hit.s) {
              var tempEnd = (0, _lodash.get)(hit, "e[" + i + "]", hit.s[i]);
              var tempRange = new _Range["default"]({
                start: hit.s[i],
                end: tempEnd,
                name: hit.label
              });
              ranges.push(tempRange);
            }
          }
        });
        isExternalHits = true;
      } else {
        isExternalHits = false;
      }

      var _this$props = _this.props,
          onAddQuery = _this$props.onAddQuery,
          onRemoveQuery = _this$props.onRemoveQuery,
          onSeek = _this$props.onSeek;
      selected.forEach(function (item) {
        var hits = (item.type === "category" || item.type === "unsorted") && item.keywords.length ? item.keywords.reduce(function (acc, keyword) {
          return [].concat(acc, getHits(keyword));
        }, []) : getHits(item);

        if (!ranges.length && hits.length && !isExternalHits) {
          hits.map(function (obj) {
            var tempRange = new _Range["default"]({
              start: obj.s,
              end: obj.s,
              name: selected.name
            });
            ranges.push(tempRange);
          });

          _this.props.markTranscript(ranges);
        } else {
          _this.props.markTranscript(ranges);
        } // keyword hits are not always in chronological order


        var sortedHits = hits.sort(function (a, b) {
          return a.s < b.s ? -1 : 1;
        }) || [];

        if (sortedHits.length && selected.length) {
          onSeek(sortedHits[0]);
        }

        onAddQuery({
          parent: item,
          hits: sortedHits,
          label: item.name || item.text,
          icon: item.type === "category" ? "tag" : "message",
          type: "keywords"
        });
      });
      deselected.forEach(function (item) {
        onRemoveQuery(item);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPanelsIcon", function (name) {
      switch (name) {
        case PanelName.Categories:
          return /*#__PURE__*/_react["default"].createElement(_index.CategoryIcon, null);

        case PanelName.Verb:
          return /*#__PURE__*/_react["default"].createElement(_index.VerbIcon, null);

        case PanelName.KeyWord:
          return /*#__PURE__*/_react["default"].createElement(_index.KeywordIcon, null);

        case PanelName.Phrase_Spotting:
          return /*#__PURE__*/_react["default"].createElement(_index.PhraseSpottingIcon, null);

        case PanelName.SelectedCat:
          return /*#__PURE__*/_react["default"].createElement(_index.EyeIcon, null);

        case PanelName.Entities:
          return /*#__PURE__*/_react["default"].createElement(_index.EntityIcon, null);

        default:
          break;
      }
    });

    return _this;
  }

  var _proto = Keywords.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (document.getElementById("exHits")) {
      document.getElementById("exHits").getElementsByTagName("i")[0].click();
    }

    this.setState({
      categories: this.props.categories
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        _this$props2$topics = _this$props2.topics,
        topics = _this$props2$topics === void 0 ? [] : _this$props2$topics,
        keyWords = _this$props2.keyWords,
        verbs = _this$props2.verbs,
        _this$props2$groups = _this$props2.groups,
        groups = _this$props2$groups === void 0 ? [] : _this$props2$groups,
        _this$props2$queries = _this$props2.queries,
        queries = _this$props2$queries === void 0 ? [] : _this$props2$queries,
        _this$props2$categori = _this$props2.categories,
        categories = _this$props2$categori === void 0 ? [] : _this$props2$categori,
        _this$props2$external = _this$props2.externalHits,
        externalHits = _this$props2$external === void 0 ? [] : _this$props2$external,
        _this$props2$entities = _this$props2.entities,
        entities = _this$props2$entities === void 0 ? [] : _this$props2$entities,
        isKeywordAnalyzerOn = _this$props2.isKeywordAnalyzerOn,
        isPhraseSupportingAnalyzerOn = _this$props2.isPhraseSupportingAnalyzerOn,
        isVerbNounAnalyzerOn = _this$props2.isVerbNounAnalyzerOn,
        isEntitiesAnalyzerOn = _this$props2.isEntitiesAnalyzerOn;
    /***
      SORTS VERB NOUN PAIRS
    ***/

    var aggregateVerbNounPairs = [];
    var clonedVerbs = (0, _lodash.cloneDeep)(verbs);
    clonedVerbs.forEach(function (verb) {
      // current verbNounPair already exists in aggregate
      if (aggregateVerbNounPairs.some(function (aggVerb) {
        return aggVerb.name === verb.name;
      })) {
        var clonedVerb = (0, _lodash.cloneDeep)(verb);
        var matchingVerb = aggregateVerbNounPairs.find(function (aggVerb) {
          return aggVerb.name === verb.name;
        });
        matchingVerb.speakers = Array.from(new Set([].concat(matchingVerb.speakers, clonedVerb.speakers)));
        matchingVerb.occurrences = [].concat(matchingVerb.occurrences, clonedVerb.occurrences);
      } else {
        aggregateVerbNounPairs.push(verb);
      }
    });

    var sortNestedByInnerOccurrence = function sortNestedByInnerOccurrence(arr) {
      arr.forEach(function (el) {
        return el.occurrences.sort(function (a, b) {
          return a.start[0] - b.start[0];
        });
      });
    };

    var sortListByOccurrences = function sortListByOccurrences(arr) {
      arr.sort(function (a, b) {
        return a.occurrences[0].start[0] - b.occurrences[0].start[0];
      });
    };

    sortNestedByInnerOccurrence(aggregateVerbNounPairs);
    sortListByOccurrences(aggregateVerbNounPairs);
    /***
      SORTS CATEGORIES
    ***/

    var sortedCategories = (0, _lodash.cloneDeep)(categories);
    var removedCats = sortedCategories.filter(function (cat) {
      return cat.keywords.length === 0;
    });

    _lodash["default"].remove(sortedCategories, function (cat) {
      return cat.keywords.length === 0;
    });

    var sortNestedByInnerKeywords = function sortNestedByInnerKeywords(arr) {
      arr.forEach(function (el) {
        return el.keywords.sort(function (a, b) {
          var _a$t, _a$t$speaker, _b$t, _b$t$speaker;

          return (a === null || a === void 0 ? void 0 : (_a$t = a.t) === null || _a$t === void 0 ? void 0 : (_a$t$speaker = _a$t.speaker) === null || _a$t$speaker === void 0 ? void 0 : _a$t$speaker[0]) - (b === null || b === void 0 ? void 0 : (_b$t = b.t) === null || _b$t === void 0 ? void 0 : (_b$t$speaker = _b$t.speaker) === null || _b$t$speaker === void 0 ? void 0 : _b$t$speaker[0]);
        });
      });
    };

    var sortListByKeywords = function sortListByKeywords(arr) {
      arr.sort(function (a, b) {
        var _a$keywords$, _a$keywords$$t, _b$keywords$, _b$keywords$$t;

        return ((_a$keywords$ = a.keywords[0]) === null || _a$keywords$ === void 0 ? void 0 : (_a$keywords$$t = _a$keywords$.t) === null || _a$keywords$$t === void 0 ? void 0 : _a$keywords$$t.speaker[0]) - ((_b$keywords$ = b.keywords[0]) === null || _b$keywords$ === void 0 ? void 0 : (_b$keywords$$t = _b$keywords$.t) === null || _b$keywords$$t === void 0 ? void 0 : _b$keywords$$t.speaker[0]);
      });
    };

    sortNestedByInnerOccurrence(sortedCategories);
    sortListByOccurrences(sortedCategories);
    var allSortedCategories = sortedCategories.concat(removedCats);
    /***
      SORTS TOPICS(KEYWORDS)
    ***/

    var sortKeywords = function sortKeywords(arr) {
      arr.forEach(function (el) {
        el.startTimes = [];
        el.keywords.forEach(function (kw) {
          Object.entries(kw.t).forEach(function (_ref) {
            var _el$startTimes;

            var k = _ref[0],
                v = _ref[1];

            (_el$startTimes = el.startTimes).push.apply(_el$startTimes, v);
          });
        });
        el.startTimes.sort(function (a, b) {
          return a - b;
        });
      });
      arr.sort(function (a, b) {
        return a.startTimes[0] - b.startTimes[0];
      });
    };

    var sortNestedKeywords = function sortNestedKeywords(arr) {
      arr.forEach(function (el) {
        el.keywords.forEach(function (kw) {
          kw.startTimes = [];
          Object.entries(kw.t).forEach(function (_ref2) {
            var _kw$startTimes;

            var k = _ref2[0],
                v = _ref2[1];

            (_kw$startTimes = kw.startTimes).push.apply(_kw$startTimes, v);
          });
          kw.startTimes.sort(function (a, b) {
            return a - b;
          });
        });
        el.keywords.sort(function (a, b) {
          return a.startTimes[0] - b.startTimes[0];
        });
      });
    };

    sortKeywords(topics);
    sortNestedKeywords(topics);
    sortKeywords(groups);
    sortNestedKeywords(groups);
    /*
    SORT ENTITIES
    */

    var sortKeywordsByOccurrence = function sortKeywordsByOccurrence(arr) {
      arr.forEach(function (el) {
        el.startTimes = [];
        el.keywords.forEach(function (occ) {
          el.startTimes.push(occ.occurrences.s);
          occ.occurrences.sort(function (a, b) {
            return a.s - b.s;
          });
        });
        el.startTimes.sort(function (a, b) {
          return a - b;
        });
      });
      arr.forEach(function (el) {
        el.keywords.sort(function (a, b) {
          var _a$keywords, _b$keywords;

          return ((_a$keywords = a.keywords) === null || _a$keywords === void 0 ? void 0 : _a$keywords[0].occurrences[0].s) - ((_b$keywords = b.keywords) === null || _b$keywords === void 0 ? void 0 : _b$keywords[0].occurrences[0].s);
        });
      });
    };

    var sortEntity = function sortEntity(arr) {
      arr.sort(function (a, b) {
        var _a$keywords2, _a$keywords2$startTim, _b$keywords2, _b$keywords2$startTim;

        return ((_a$keywords2 = a.keywords) === null || _a$keywords2 === void 0 ? void 0 : (_a$keywords2$startTim = _a$keywords2.startTimes) === null || _a$keywords2$startTim === void 0 ? void 0 : _a$keywords2$startTim[0]) - ((_b$keywords2 = b.keywords) === null || _b$keywords2 === void 0 ? void 0 : (_b$keywords2$startTim = _b$keywords2.startTimes) === null || _b$keywords2$startTim === void 0 ? void 0 : _b$keywords2$startTim[0]);
      });
    };

    sortKeywordsByOccurrence(entities);
    sortEntity(entities);
    return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_List["default"], {
      onChange: this.handleChange,
      selections: this.getKeywordSelections(queries)
    }, (0, _lodash.get)(externalHits, "0.hits.length") > 0 ? /*#__PURE__*/_react["default"].createElement(_List["default"].Section, {
      id: "exHits",
      title: externalHits[0].SectionTitle || "Selected Hits"
    }, externalHits.map(function (eHits) {
      return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
        key: eHits.groupTitle,
        icon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
          type: "tag",
          theme: "filled"
        }),
        title: eHits.groupTitle || "All Hits",
        value: eHits,
        badge: eHits.hits.reduce(function (total, value) {
          return total + value.s.length;
        }, 0)
      }, eHits.keywords.length ? eHits.keywords.map(function (keyword) {
        return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
          key: keyword.name,
          icon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
            type: "message",
            theme: "filled"
          }),
          title: keyword.name,
          value: keyword,
          badge: getCount(keyword)
        });
      }) : null);
    })) : null, /*#__PURE__*/_react["default"].createElement(_List["default"].Section, {
      title: "Categories",
      icon: this.setPanelsIcon(PanelName.Categories)
    }, allSortedCategories.map(function (category) {
      var _category$occurrences;

      return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
        key: category.name // icon={<Icon type="tag" theme="filled" />}
        ,
        icon: _this2.setPanelsIcon(PanelName.SelectedCat),
        title: (0, _lodash.last)(category.name.split("_").filter(function (i) {
          return i;
        })),
        value: category,
        badge: category.keywords.reduce(function (acc, keyword) {
          return getCount(keyword) + acc;
        }, 0)
      }, category === null || category === void 0 ? void 0 : (_category$occurrences = category.occurrences) === null || _category$occurrences === void 0 ? void 0 : _category$occurrences.map(function (keyword) {
        var _keyword$hits;

        return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
          key: keyword === null || keyword === void 0 ? void 0 : keyword.exact,
          icon: _this2.setPanelsIcon(PanelName.SelectedCat),
          title: keyword.exact,
          value: keyword // badge={getCount(keyword)}
          ,
          badge: (_keyword$hits = keyword.hits) === null || _keyword$hits === void 0 ? void 0 : _keyword$hits.length
        });
      }));
    })), isVerbNounAnalyzerOn && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
      className: "panel-hr-line"
    }), /*#__PURE__*/_react["default"].createElement(_List["default"].Section, {
      title: "VERB/NOUNS",
      icon: this.setPanelsIcon(PanelName.Verb)
    }, aggregateVerbNounPairs.map(function (category) {
      return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
        key: category.name,
        icon: _this2.setPanelsIcon(PanelName.SelectedCat),
        title: category.name,
        value: category,
        badge: category.occurrences.reduce(function (total, value) {
          return total + value.start.length;
        }, 0)
      });
    }))), isKeywordAnalyzerOn && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
      className: "panel-hr-line"
    }), /*#__PURE__*/_react["default"].createElement(_List["default"].Section, {
      title: "KEYWORDS",
      icon: this.setPanelsIcon(PanelName.KeyWord)
    }, topics.map(function (topic) {
      return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
        key: topic.name // icon={<Icon type="tag" theme="filled" />}
        ,
        icon: _this2.setPanelsIcon(PanelName.SelectedCat),
        title: (0, _lodash.last)(topic.name.split("_").filter(function (i) {
          return i;
        })),
        value: topic,
        badge: topic.keywords.reduce(function (acc, keyword) {
          return getCount(keyword) + acc;
        }, 0)
      }, topic.keywords.map(function (keyword) {
        return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
          key: keyword.name,
          icon: _this2.setPanelsIcon(PanelName.SelectedCat),
          title: keyword.name,
          value: keyword,
          badge: getCount(keyword)
        });
      }));
    }))), isPhraseSupportingAnalyzerOn && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
      className: "panel-hr-line"
    }), /*#__PURE__*/_react["default"].createElement(_List["default"].Section, {
      title: "Phrase Spotting",
      icon: this.setPanelsIcon(PanelName.Phrase_Spotting)
    }, groups.map(function (group) {
      return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
        key: group.name,
        icon: _this2.setPanelsIcon(PanelName.SelectedCat),
        title: group.name,
        value: group,
        badge: group.keywords.reduce(function (acc, keyword) {
          return getCount(keyword) + acc;
        }, 0)
      }, group.keywords.map(function (keyword) {
        return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
          key: keyword.name,
          icon: _this2.setPanelsIcon(PanelName.SelectedCat),
          title: keyword.name,
          value: keyword,
          badge: getCount(keyword)
        });
      }));
    }))), isEntitiesAnalyzerOn && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", {
      className: "panel-hr-line"
    }), /*#__PURE__*/_react["default"].createElement(_List["default"].Section, {
      title: "Entities",
      icon: this.setPanelsIcon(PanelName.Entities)
    }, entities.map(function (entity) {
      var _entity$keywords;

      return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
        icon: _this2.setPanelsIcon(PanelName.SelectedCat),
        key: entity.name,
        title: entity.name,
        value: entity,
        badge: entity.keywords.reduce(function (acc, keyword) {
          return keyword.occurrences.length + acc;
        }, 0)
      }, entity === null || entity === void 0 ? void 0 : (_entity$keywords = entity.keywords) === null || _entity$keywords === void 0 ? void 0 : _entity$keywords.map(function (keyword) {
        return /*#__PURE__*/_react["default"].createElement(_List["default"].Node, {
          key: keyword.text,
          icon: _this2.setPanelsIcon(PanelName.SelectedCat),
          title: keyword.text,
          value: keyword,
          badge: keyword.occurrences.length
        });
      }));
    })))));
  };

  return Keywords;
}(_react["default"].PureComponent);

_defineProperty(Keywords, "defaultProps", {
  queryState: {
    hits: [],
    queries: []
  }
});

var _default = (0, _connectToMedia["default"])(function (state) {
  return _extends({}, state.media, {
    queries: state.query
  });
})(Keywords);

exports["default"] = _default;